import script from "./MazdaAbPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./MazdaAbPanel.vue?vue&type=script&setup=true&lang=js"

import "./MazdaAbPanel.vue?vue&type=style&index=0&id=4b7489e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b7489e0"]])

export default __exports__